import React from "react";

const HomePage = () => {

    return (
        <div>
            Welcome to Eezee Admin
        </div>
    );
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/containers/home-page.js